module.exports = __webpack_public_path__ + "assets/img/q1.50a581a7.png";